var _style, _defs, _defs2, _rect, _defs3, _rect2, _defs4, _rect3, _defs5, _rect4, _defs6, _rect5, _defs7, _defs8, _rect6, _defs9, _rect7, _defs10, _rect8, _defs11, _rect9, _defs12, _rect10, _g, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLotHist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.2 224.6",
    style: {
      enableBackground: "new 0 0 291.2 224.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000041994683581698562360000012482305546567867014_);fill:none;stroke:#000000;stroke-width:1.07;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{clip-path:url(#SVGID_00000045590467460834505210000017697875428951621023_);enable-background:new    ;}\n\t.st4{fill:none;}\n\t.st5{clip-path:url(#SVGID_00000103236766869086862840000018094385478973093789_);enable-background:new    ;}\n\t.st6{clip-path:url(#SVGID_00000046319342360155404700000002489451336212123819_);enable-background:new    ;}\n\t.st7{clip-path:url(#SVGID_00000039818891398061873660000012412724267492604561_);enable-background:new    ;}\n\t.st8{clip-path:url(#SVGID_00000142160964020896145500000011188651047193165749_);enable-background:new    ;}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000032615208541729928990000008092179709102004610_);fill:none;stroke:#000000;stroke-width:1.07;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{clip-path:url(#SVGID_00000154390744964028599160000003696085608065424319_);enable-background:new    ;}\n\t.st11{clip-path:url(#SVGID_00000134929928230568110870000010106602649964462264_);enable-background:new    ;}\n\t.st12{clip-path:url(#SVGID_00000054248988645261908020000008946402740172609434_);enable-background:new    ;}\n\t.st13{clip-path:url(#SVGID_00000114058530433689836910000007437557287429162658_);enable-background:new    ;}\n\t.st14{clip-path:url(#SVGID_00000099638599640816821890000007213691512082724002_);enable-background:new    ;}\n\t.st15{fill:none;stroke:#707070;stroke-width:0.2188;stroke-miterlimit:10;}\n\t.st16{enable-background:new    ;}\n\t.st17{fill:#545454;}\n\t.st18{fill:#57A1D8;stroke:#FFFFFF;stroke-width:0.2188;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st19{fill:#C6C6C6;stroke:#FFFFFF;stroke-width:0.2188;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#707070;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#707070;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.9973,0.9973;}\n\t.st22{fill:#9B9B9B;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000051356737087309629650000010106155503864062906_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031926448737132759440000003296275411780644279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000031926448737132759440000003296275411780644279_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.07,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: -20.6,
    y1: 497.4,
    x2: -20.6,
    y2: -18.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000134950286961781716710000014735714647431958177_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178173061654345131870000006796196053243174796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134950286961781716710000014735714647431958177_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178173061654345131870000006796196053243174796_)",
      enableBackground: "new"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -30.4,
    y: 469.6,
    className: "st4",
    width: 4.9,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -30.3965 477.1039)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "0")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173873236657646873080000017982773839683564986_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119806244778471723500000016033323118755218345_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173873236657646873080000017982773839683564986_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119806244778471723500000016033323118755218345_)",
      enableBackground: "new"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -45.1,
    y: 347.6,
    className: "st4",
    width: 19.6,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -45.0792 355.1234)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "2000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000049937633166372510720000008519151010186542519_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006691486342848377540000010706468180095208382_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049937633166372510720000008519151010186542519_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006691486342848377540000010706468180095208382_)",
      enableBackground: "new"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -45.1,
    y: 225.6,
    className: "st4",
    width: 19.6,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -45.0792 233.1341)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "4000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111154219839501551630000010644048732248455051_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114036812904781910180000007461758390103183022_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111154219839501551630000010644048732248455051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114036812904781910180000007461758390103183022_)",
      enableBackground: "new"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -45.1,
    y: 103.6,
    className: "st4",
    width: 19.6,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -45.0792 111.1537)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "6000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000015322383372340521210000003078920677812245166_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007388365748131211060000017113381441847308192_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015322383372340521210000003078920677812245166_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000007388365748131211060000017113381441847308192_)",
      enableBackground: "new"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -45.1,
    y: -18.4,
    className: "st4",
    width: 19.6,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -45.0792 -10.8263)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "8000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172405066591988413180000002260694425533086112_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104679455843847052950000003455483530359987859_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172405066591988413180000002260694425533086112_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000104679455843847052950000003455483530359987859_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.07,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: -20.6,
    y1: 497.4,
    x2: 679,
    y2: 497.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000156588502354314127460000009747689088105439659_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111885613799140859420000010880922543521831841_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156588502354314127460000009747689088105439659_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111885613799140859420000010880922543521831841_)",
      enableBackground: "new"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 501.1,
    className: "st4",
    width: 4.9,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 24.6806 508.6342)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "0")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054957072805873475780000013804809642905308801_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131340823572378376530000017597325590927655560_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054957072805873475780000013804809642905308801_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131340823572378376530000017597325590927655560_)",
      enableBackground: "new"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 168.4,
    y: 501.1,
    className: "st4",
    width: 19.6,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 168.3994 508.6342)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "5000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000106124030908456513540000016463852379587391409_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118393253815279939740000000656842634027470765_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106124030908456513540000016463852379587391409_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118393253815279939740000000656842634027470765_)",
      enableBackground: "new"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 501.1,
    className: "st4",
    width: 24.5,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 317.0019 508.6342)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "10000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000017505770737702341990000017297046055147865788_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093861655696977122260000012920792793443466144_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017505770737702341990000017297046055147865788_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093861655696977122260000012920792793443466144_)",
      enableBackground: "new"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 468.1,
    y: 501.1,
    className: "st4",
    width: 24.5,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 468.0624 508.6342)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "15000")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094579087408922208710000017754743239196500395_",
    x: -50.6,
    y: -23.9,
    width: 735,
    height: 540
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180331258948791134480000016985498822592601237_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094579087408922208710000017754743239196500395_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000180331258948791134480000016985498822592601237_)",
      enableBackground: "new"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 619.1,
    y: 501.1,
    className: "st4",
    width: 24.5,
    height: 10.4
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 619.122 508.6342)",
    style: {
      fill: "#4D4D4D",
      fontFamily: "'ArialMT'",
      fontSize: "8.8px"
    }
  }, "20000")))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000160900443920962264730000010298312273642554539_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 1.1,
    y1: 210.6,
    x2: 288.3,
    y2: 210.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2.5,217.3c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6 C2.5,219.2,2.5,217.3,2.5,217.3z M5.4,217.4c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8 V217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M9.3,220.5c0.3,0.3,0.6,0.4,1.2,0.4c0.8,0,1.1-0.3,1.1-0.8c0-0.3-0.1-0.5-0.3-0.6s-0.3-0.1-0.8-0.2 c-0.6-0.1-0.9-0.2-1.1-0.4C9.2,218.7,9,218.4,9,218c0-0.9,0.5-1.3,1.5-1.3c0.8,0,1.3,0.2,1.6,0.7l-0.5,0.3c-0.3-0.3-0.6-0.5-1-0.5 c-0.6,0-0.9,0.3-0.9,0.7c0,0.2,0.1,0.4,0.3,0.5s0.3,0.1,0.7,0.2c0.7,0.1,1,0.2,1.2,0.4c0.3,0.2,0.4,0.5,0.4,1 c0,0.9-0.6,1.3-1.8,1.3c-0.8,0-1.4-0.2-1.8-0.7L9.3,220.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M16.4,221.2c-0.3,0.3-0.7,0.4-1.2,0.4c-1.2,0-1.7-0.6-1.7-2v-0.7c0-1.4,0.5-2,1.7-2c0.6,0,1,0.2,1.3,0.5 l0.1-0.4h0.6v6.5h-0.7L16.4,221.2z M14.2,219.5c0,1,0.4,1.5,1.1,1.5c0.7,0,1.1-0.5,1.1-1.4v-0.7c0-0.9-0.4-1.4-1.1-1.4 c-0.7,0-1.1,0.5-1.1,1.5C14.2,219,14.2,219.5,14.2,219.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M19.3,217v2.5c0,0.4,0,0.7,0.1,0.9c0.1,0.4,0.4,0.6,0.9,0.6c0.7,0,1-0.5,1-1.7V217H22v4.5h-0.5l-0.1-0.5 c-0.3,0.4-0.6,0.6-1.2,0.6c-0.8,0-1.3-0.3-1.5-0.9c-0.1-0.3-0.1-0.6-0.1-1.1V217H19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M26.1,218.5c0-0.4,0-0.5-0.2-0.7s-0.5-0.3-0.8-0.3c-0.4,0-0.8,0.2-1.1,0.5l-0.5-0.4c0.4-0.5,0.9-0.7,1.6-0.7 s1.2,0.2,1.5,0.7c0.1,0.3,0.2,0.5,0.2,1.1v2.9h-0.6l-0.1-0.3c-0.3,0.3-0.6,0.4-1.3,0.4c-1.2,0-1.6-0.4-1.6-1.3 c0-1,0.4-1.4,1.7-1.4H26L26.1,218.5L26.1,218.5z M25.1,219.4c-0.8,0-1.1,0.2-1.1,0.8s0.3,0.8,1.1,0.8c0.5,0,0.8-0.1,0.9-0.3 c0.1-0.1,0.1-0.3,0.1-0.6v-0.7H25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M28.4,217H29l0.1,0.4c0.3-0.4,0.6-0.5,1.1-0.5c0.3,0,0.6,0.1,0.9,0.2l-0.3,0.6c-0.2-0.2-0.4-0.2-0.6-0.2 c-0.7,0-0.9,0.5-0.9,1.8v2.2h-0.7V217H28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M32.4,219.6c0,0.9,0.4,1.4,1.3,1.4c0.5,0,0.8-0.1,1-0.4l0.5,0.3c-0.4,0.5-0.8,0.7-1.6,0.7 c-1.3,0-1.9-0.7-1.9-2.1v-0.4c0-1.5,0.6-2.2,1.8-2.2s1.8,0.7,1.8,2.2v0.3h-3L32.4,219.6L32.4,219.6z M34.7,218.8L34.7,218.8 c0-0.4-0.1-0.8-0.2-1c-0.2-0.3-0.5-0.4-0.9-0.4c-0.5,0-0.8,0.1-1,0.5c-0.1,0.2-0.2,0.5-0.2,0.8v0.1L34.7,218.8L34.7,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M38.2,217.6V217h0.6v-0.7c0-0.9,0.3-1.2,1.3-1.2h0.4v0.6h-0.3c-0.6,0-0.7,0.1-0.7,0.7v0.6h1v0.6h-1v3.9h-0.7 v-3.9L38.2,217.6L38.2,217.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M42.1,219.6c0,0.9,0.4,1.4,1.3,1.4c0.5,0,0.8-0.1,1-0.4l0.5,0.3c-0.4,0.5-0.8,0.7-1.6,0.7 c-1.3,0-1.9-0.7-1.9-2.1v-0.4c0-1.5,0.6-2.2,1.8-2.2s1.8,0.7,1.8,2.2v0.3h-3v0.2H42.1z M44.4,218.8L44.4,218.8 c0-0.4-0.1-0.8-0.2-1c-0.2-0.3-0.5-0.4-0.9-0.4c-0.5,0-0.8,0.1-1,0.5c-0.1,0.2-0.2,0.5-0.2,0.8v0.1L44.4,218.8L44.4,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M47,219.6c0,0.9,0.4,1.4,1.3,1.4c0.5,0,0.8-0.1,1-0.4l0.5,0.3c-0.4,0.5-0.8,0.7-1.6,0.7 c-1.3,0-1.9-0.7-1.9-2.1v-0.4c0-1.5,0.6-2.2,1.8-2.2s1.8,0.7,1.8,2.2v0.3h-3v0.2H47z M49.3,218.8L49.3,218.8c0-0.4-0.1-0.8-0.2-1 c-0.2-0.3-0.5-0.4-0.9-0.4c-0.5,0-0.8,0.1-1,0.5c-0.1,0.2-0.2,0.5-0.2,0.8v0.1L49.3,218.8L49.3,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M50.9,217.6V217h0.5v-1.4h0.7v1.4H53v0.6h-0.9v2.5c0,0.6,0.2,0.8,0.8,0.8h0.2v0.6h-0.2 c-1.2,0-1.5-0.3-1.5-1.5v-2.4L50.9,217.6L50.9,217.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M67.2,215.4h2.9v0.6h-2.3l-0.2,2c0.3-0.2,0.6-0.2,1-0.2c0.6,0,1.1,0.2,1.4,0.6c0.2,0.3,0.3,0.8,0.3,1.4 c0,0.7-0.1,1.1-0.4,1.5s-0.9,0.6-1.5,0.6c-1,0-1.6-0.5-1.8-1.4l0.7-0.1c0.1,0.5,0.5,0.8,1.1,0.8c0.7,0,1.1-0.5,1.1-1.4 c0-1-0.3-1.5-1.1-1.5c-0.4,0-0.7,0.1-1,0.4l-0.5-0.1L67.2,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M71.9,221h0.8l-0.6,2.6h-0.6L71.9,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M74.1,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M76.9,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M78.9,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M81.8,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M83.8,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M86.7,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M136.1,216.2l-1.1,0.5l-0.2-0.6l1.6-0.7h0.5v6.4h-0.7v-5.6H136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M139.4,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M142.2,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M144.5,221h0.8l-0.6,2.6h-0.6L144.5,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M146.7,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M149.6,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M151.6,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M154.5,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M156.5,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M159.3,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M203.8,216.2l-1.1,0.5l-0.2-0.6l1.6-0.7h0.5v6.4h-0.7v-5.6H203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M207.6,215.4h2.9v0.6h-2.3l-0.2,2c0.3-0.2,0.6-0.2,1-0.2c0.6,0,1.1,0.2,1.4,0.6c0.2,0.3,0.3,0.8,0.3,1.4 c0,0.7-0.1,1.1-0.4,1.5c-0.3,0.4-0.9,0.6-1.5,0.6c-1,0-1.6-0.5-1.8-1.4l0.7-0.1c0.1,0.5,0.5,0.8,1.1,0.8c0.7,0,1.1-0.5,1.1-1.4 c0-1-0.3-1.5-1.1-1.5c-0.4,0-0.7,0.1-1,0.4l-0.5-0.1L207.6,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M212.2,221h0.8l-0.6,2.6h-0.6L212.2,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M214.5,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M217.3,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M219.3,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M222.2,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M224.2,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M227.1,217.8 c0-1.3-0.3-1.8-1.1-1.8s-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8s1.1-0.5,1.1-1.8V217.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M262.2,221.4l1.8-2.3c0.7-0.9,1-1.5,1-2.1s-0.3-0.9-1-0.9c-0.6,0-0.9,0.3-1.1,1l-0.7-0.1 c0.1-1,0.8-1.5,1.8-1.5c1.1,0,1.7,0.6,1.7,1.6c0,0.8-0.3,1.3-1.2,2.6l-1.3,1.7h2.6v0.6h-3.5L262.2,221.4L262.2,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M267.2,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M270.1,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M272.4,221h0.8l-0.6,2.6H272L272.4,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M274.6,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M277.5,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M279.5,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M282.3,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M284.3,217.7c0-0.8,0.1-1.4,0.4-1.7c0.3-0.4,0.8-0.6,1.4-0.6c0.7,0,1.2,0.2,1.5,0.7c0.2,0.3,0.3,0.9,0.3,1.6 v1.9c0,0.8-0.1,1.4-0.4,1.7c-0.3,0.4-0.8,0.6-1.4,0.6c-0.7,0-1.2-0.2-1.5-0.7c-0.2-0.3-0.3-0.9-0.3-1.6V217.7z M287.2,217.8 c0-1.3-0.3-1.8-1.1-1.8c-0.8,0-1.1,0.5-1.1,1.8v1.7c0,1.3,0.3,1.8,1.1,1.8c0.8,0,1.1-0.5,1.1-1.8V217.8z"
  })))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 204.5,
    className: "st18",
    width: 13.9,
    height: 5.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 169.9,
    className: "st18",
    width: 13.9,
    height: 40.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 5,
    className: "st18",
    width: 13.9,
    height: 205.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 146.5,
    className: "st18",
    width: 13.9,
    height: 63.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2,
    y: 138.8,
    className: "st18",
    width: 13.9,
    height: 71.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1,
    y: 155.6,
    className: "st19",
    width: 13.9,
    height: 54.6
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 180.5,
    className: "st19",
    width: 13.9,
    height: 29.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 102.9,
    y: 189.3,
    className: "st19",
    width: 13.9,
    height: 20.9
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 195.7,
    className: "st19",
    width: 13.9,
    height: 14.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 130.7,
    y: 199.1,
    className: "st19",
    width: 13.9,
    height: 11.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 194.9,
    className: "st19",
    width: 13.9,
    height: 15.3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 158.6,
    y: 202.8,
    className: "st19",
    width: 13.9,
    height: 7.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 204,
    className: "st19",
    width: 13.9,
    height: 6.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 205.8,
    className: "st19",
    width: 13.9,
    height: 4.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 205.1,
    className: "st19",
    width: 13.9,
    height: 5.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2,
    y: 207,
    className: "st19",
    width: 13.9,
    height: 3.3
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 228.1,
    y: 207.6,
    className: "st19",
    width: 13.9,
    height: 2.6
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 242.1,
    y: 207.2,
    className: "st19",
    width: 13.9,
    height: 3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 208,
    className: "st19",
    width: 13.9,
    height: 2.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 269.9,
    y: 208.8,
    className: "st19",
    width: 13.9,
    height: 1.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 75.8,
    y1: 4.4,
    x2: 75.8,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 75.8,
    y1: 5.9,
    x2: 75.8,
    y2: 210.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 75.8,
    y1: 211.3,
    x2: 75.8,
    y2: 211.8
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M85.1,14.9l-0.5,1.6h-0.9l2.6-7.1h0.8l2.6,7.1h-0.9l-0.5-1.6H85.1z M86.7,10.4l-1.3,3.8H88L86.7,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M91.3,9.4v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V9.4H91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M94.3,9.4v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V9.4H94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M99.2,9.4v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7H100c-1.3,0-1.6-0.3-1.6-1.7V9.4H99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M101.1,13.6c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V13.6z M104.5,13.7c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M106.4,12.1v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M110.5,15.4c0.3,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.4,0.6,0.4,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L110.5,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M117.2,11.3v-0.8l4.1,2.1v0.5l-4.1,2.1v-0.8l3.2-1.6L117.2,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M125,9.4h3.2v0.7h-2.5l-0.2,2.3c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1.2,0.3,1.5,0.7c0.3,0.4,0.4,0.8,0.4,1.6 c0,0.7-0.1,1.3-0.5,1.6c-0.4,0.4-0.9,0.6-1.7,0.6c-1.2,0-1.8-0.5-2-1.5l0.8-0.1c0.1,0.6,0.5,0.9,1.2,0.9c0.8,0,1.3-0.5,1.3-1.5 c0-1.1-0.4-1.6-1.2-1.6c-0.4,0-0.8,0.1-1.1,0.4l-0.6-0.1L125,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M130.2,15.5h0.9l-0.7,2.9h-0.7L130.2,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M132.7,11.9c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 V14c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V11.9z M135.9,12 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M138.1,11.9c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 V14c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V11.9z M141.3,12 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M143.5,11.9c0-0.9,0.1-1.5,0.4-1.9c0.4-0.5,0.8-0.7,1.6-0.7c0.8,0,1.3,0.3,1.6,0.8c0.2,0.4,0.4,0.9,0.4,1.8 V14c0,0.9-0.1,1.5-0.4,1.9c-0.4,0.5-0.8,0.7-1.6,0.7c-0.8,0-1.3-0.3-1.6-0.8c-0.2-0.4-0.4-0.9-0.4-1.8V11.9z M146.7,12 c0-1.4-0.3-2-1.2-2c-0.8,0-1.2,0.6-1.2,2v1.9c0,1.4,0.3,2,1.2,2c0.8,0,1.2-0.6,1.2-2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M151.1,15.4c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L151.1,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M155.5,12.1v-0.7h0.6v-0.8c0-1,0.3-1.3,1.4-1.3h0.5V10h-0.3c-0.6,0-0.8,0.1-0.8,0.8v0.7h1.1v0.7h-1.1v4.4 h-0.8v-4.4H155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M164.5,13.2c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.7,1.8-0.7c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V13.2z M163.4,14.2c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M167.1,11.5h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M171.5,14.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.7,2,2.4v0.4h-3.3V14.4z M174,13.6L174,13.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M179.1,9.4v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7V9.4H179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M184,13.2c0-0.4-0.1-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.7,1.8-0.7c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V13.2z M182.8,14.2c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H182.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M186.5,11.5h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M193.5,16.1c-0.3,0.3-0.7,0.5-1.4,0.5c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2 c0.7,0,1.1,0.2,1.5,0.5l0.1-0.4h0.6v5c0,1.6-0.7,2.3-2.1,2.3c-0.8,0-1.4-0.2-1.7-0.8l0.6-0.4c0.3,0.4,0.6,0.5,1.1,0.5 c0.9,0,1.3-0.5,1.4-1.6L193.5,16.1z M191,14.3c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5 c-0.8,0-1.2,0.5-1.2,1.6V14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M196.6,14.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.7,2,2.4v0.4h-3.3V14.4z M199.1,13.6L199.1,13.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M85.2,26.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.7,2,2.4v0.4h-3.3V26.4z M87.7,25.6L87.7,25.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M90,23.5h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.1,0.7,0.1,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5H90V23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M95.5,25.6c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V25.6z M98.8,25.7c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M102,23.5v2.8c0,0.5,0,0.8,0.1,1c0.2,0.4,0.5,0.6,1,0.6c0.8,0,1.2-0.5,1.2-1.9v-2.5h0.8v5h-0.6l-0.1-0.6 c-0.3,0.4-0.7,0.6-1.4,0.6c-0.9,0-1.4-0.3-1.6-1c-0.1-0.3-0.1-0.7-0.1-1.3v-2.9H102z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M109.8,28.1c-0.3,0.3-0.8,0.5-1.4,0.5c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2 c0.7,0,1.1,0.2,1.5,0.5l0.1-0.4h0.6v5c0,1.6-0.7,2.3-2.1,2.3c-0.8,0-1.4-0.2-1.7-0.8l0.6-0.4c0.3,0.4,0.6,0.5,1.1,0.5 c0.9,0,1.3-0.5,1.4-1.6L109.8,28.1z M107.4,26.3c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5 c-0.8,0-1.2,0.5-1.2,1.6V26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M112.4,21.4h0.8v2.5c0.3-0.3,0.7-0.5,1.3-0.5c0.9,0,1.4,0.3,1.7,1c0.1,0.3,0.1,0.7,0.1,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.8v2.6h-0.8V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M120.2,24.1v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M123.2,25.6c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V25.6z M126.5,25.7c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M130.9,21.4h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l0,0.4h-0.6V21.4z M134.2,25.7c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M137.2,26.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.7,2,2.4v0.4h-3.3V26.4z M139.7,25.6L139.7,25.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M147.6,27.8c-0.4,0.5-0.9,0.8-1.7,0.8c-1.3,0-2-0.8-2-2.3v-0.4c0-1.7,0.6-2.5,2-2.5c0.8,0,1.3,0.3,1.7,0.8 l-0.6,0.4c-0.3-0.4-0.5-0.5-1-0.5c-0.8,0-1.2,0.6-1.2,1.7v0.5c0,1,0.4,1.6,1.3,1.6c0.5,0,0.8-0.1,1.1-0.5L147.6,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M148.6,25.6c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V25.6z M152,25.7c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M154.4,23.5h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.2,0.7,0.2,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M160,27.4c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L160,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M164.8,21.3h0.8v1.1h-0.8V21.3z M164.8,23.5h0.8v5h-0.8V23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M170.5,28.1C170.5,28.1,170.5,28.1,170.5,28.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1h-0.6L170.5,28.1z  M167.9,26.3c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M173.6,26.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.7,2,2.4v0.4h-3.3V26.4z M176.1,25.6L176.1,25.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M178.4,23.5h0.6l0.1,0.5c0.3-0.4,0.6-0.6,1.2-0.6c0.3,0,0.6,0.1,1,0.3l-0.3,0.7c-0.3-0.2-0.5-0.2-0.7-0.2 c-0.7,0-1,0.6-1,2v2.4h-0.8V23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M182.8,26.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.7,2,2.4v0.4h-3.3V26.4z M185.4,25.6L185.4,25.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H185.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M190.9,28.1C190.8,28.1,190.8,28.1,190.9,28.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.7,0.3-1.3,0.3 c-1.3,0-1.9-0.7-1.9-2.2v-0.8c0-1.5,0.6-2.2,1.9-2.2c0.4,0,0.8,0.1,1.1,0.2c0,0,0.1,0.1,0.3,0.2v-2.5h0.8v7.1h-0.6L190.9,28.1z  M188.3,26.3c0,1.1,0.4,1.6,1.2,1.6c0.8,0,1.2-0.5,1.2-1.5v-0.8c0-1-0.4-1.5-1.2-1.5c-0.8,0-1.2,0.5-1.2,1.6V26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M84.6,35.5h0.6l0.1,0.4c0.3-0.4,0.8-0.5,1.5-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.6,0-1-0.1-1.4-0.5v2.6h-0.8V35.5z M87.8,37.7c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8c0,1,0.4,1.5,1.2,1.5 c0.8,0,1.2-0.5,1.2-1.6V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M90,37.6c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V37.6z M93.4,37.7c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M95.3,36.1v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M99.7,38.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4s2,0.7,2,2.4v0.4h-3.3V38.4z M102.2,37.6L102.2,37.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M104.5,35.5h0.6l0.1,0.6c0.3-0.5,0.7-0.7,1.4-0.7c0.9,0,1.5,0.3,1.7,1c0.1,0.3,0.1,0.7,0.1,1.3v2.9h-0.8v-2.8 c0-1.2-0.3-1.6-1.1-1.6c-0.9,0-1.2,0.5-1.2,1.9v2.5h-0.8V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M109.7,36.1v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M113.5,33.3h0.8v1.1h-0.8V33.3z M113.5,35.5h0.8v5h-0.8V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M118.8,37.2c0-0.4,0-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.9-0.4c-0.5,0-0.9,0.2-1.2,0.5l-0.5-0.4 c0.4-0.5,1-0.7,1.8-0.7c0.8,0,1.3,0.2,1.6,0.7c0.2,0.3,0.2,0.6,0.2,1.2v3.2h-0.6l-0.1-0.4c-0.3,0.3-0.7,0.4-1.5,0.4 c-1.3,0-1.8-0.4-1.8-1.5c0-1.2,0.5-1.5,1.9-1.5h1.2V37.2z M117.6,38.2c-0.9,0-1.2,0.3-1.2,0.9c0,0.6,0.3,0.8,1.2,0.8 c0.5,0,0.9-0.1,1-0.3c0.1-0.1,0.1-0.3,0.1-0.7v-0.8H117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M122.1,33.4v5.5c0,0.7,0.2,0.9,0.8,0.9h0.3v0.7h-0.3c-1.3,0-1.6-0.3-1.6-1.7v-5.5H122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M126.2,39.4c0.3,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.4,0.6,0.4,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L126.2,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M130.8,37.6c0-1.5,0.6-2.2,2.1-2.2c1.4,0,2.1,0.7,2.1,2.2v0.8c0,1.5-0.6,2.2-2.1,2.2c-1.4,0-2.1-0.7-2.1-2.2 V37.6z M134.1,37.7c0-1.1-0.4-1.6-1.3-1.6c-0.9,0-1.3,0.5-1.3,1.6v0.7c0,1.1,0.4,1.6,1.3,1.6c0.9,0,1.3-0.5,1.3-1.6V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M136.1,36.1v-0.7h0.6v-0.8c0-1,0.3-1.3,1.4-1.3h0.5V34h-0.3c-0.6,0-0.8,0.1-0.8,0.8v0.7h1.1v0.7h-1.1v4.4 h-0.8v-4.4H136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M139.7,36.1v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7H142c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M145.5,39.4c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L145.5,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M150.2,33.3h0.8v1.1h-0.8V33.3z M150.2,35.5h0.8v5h-0.8V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M152.4,36.1v-0.7h0.6l0-1.6h0.7v1.6h1v0.7h-1v2.8c0,0.7,0.2,0.9,0.8,0.9h0.2v0.7h-0.2c-1.3,0-1.6-0.3-1.6-1.7 v-2.7H152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M156.7,38.4c0,1,0.5,1.6,1.4,1.6c0.5,0,0.9-0.1,1.1-0.5l0.6,0.4c-0.4,0.5-0.9,0.8-1.8,0.8 c-1.4,0-2.1-0.8-2.1-2.4v-0.4c0-1.7,0.6-2.4,2-2.4c1.4,0,2,0.7,2,2.4v0.4h-3.3V38.4z M159.2,37.6L159.2,37.6c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.5-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.5c-0.1,0.2-0.2,0.6-0.2,0.9v0.1H159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M161.7,39.4c0.4,0.4,0.7,0.5,1.3,0.5c0.8,0,1.3-0.3,1.3-0.8c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.3-0.1-0.9-0.2 c-0.7-0.1-1-0.2-1.2-0.4c-0.3-0.2-0.4-0.5-0.4-1c0-1,0.6-1.5,1.7-1.5c0.8,0,1.4,0.2,1.8,0.8l-0.6,0.4c-0.3-0.4-0.6-0.5-1.2-0.5 c-0.6,0-1,0.3-1,0.8c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.3,0.1,0.8,0.2c0.8,0.1,1.1,0.2,1.4,0.4c0.3,0.2,0.5,0.6,0.5,1.1 c0,1-0.7,1.5-2,1.5c-0.9,0-1.6-0.3-2-0.8L161.7,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M168.4,33.4h0.8v2.5c0.4-0.3,0.8-0.5,1.4-0.5c1.3,0,1.9,0.7,1.9,2.2v0.8c0,1.5-0.6,2.2-1.9,2.2 c-0.5,0-0.9-0.1-1.2-0.3c0,0-0.1-0.1-0.3-0.2l-0.1,0.4h-0.6V33.4z M171.7,37.7c0-1.1-0.4-1.6-1.2-1.6c-0.8,0-1.2,0.5-1.2,1.5v0.8 c0,1,0.4,1.5,1.2,1.5c0.8,0,1.2-0.5,1.2-1.6V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M173.4,35.5h0.8l1.5,4.1l1.3-4.1h0.8l-2,5.8c-0.5,1.3-0.7,1.5-2,1.5v-0.7c0.8,0,0.9-0.1,1.2-0.9l0.2-0.7 L173.4,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M185.6,38.8c-0.1,1.1-0.9,1.8-2.3,1.8c-0.9,0-1.5-0.3-2-0.9c-0.3-0.5-0.4-1-0.4-2v-1.5c0-1.1,0.2-1.7,0.5-2.1 c0.4-0.5,1-0.8,1.9-0.8c1.4,0,2.2,0.6,2.2,1.8l-0.8,0.1c-0.1-0.7-0.6-1.2-1.5-1.2c-1.1,0-1.6,0.6-1.6,2.3v1.4 c0,1.6,0.4,2.3,1.6,2.3c0.9,0,1.4-0.4,1.5-1.2L185.6,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M187.4,33.4h4.2v0.7h-3.3v2.5h2.9v0.7h-2.9v2.6h3.4v0.7h-4.2V33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M197.3,40c-0.4,0.4-1,0.6-1.7,0.6c-0.9,0-1.6-0.3-2-0.9c-0.3-0.4-0.5-1-0.5-1.9v-1.8c0-1,0.2-1.6,0.6-2 c0.5-0.5,1-0.7,1.9-0.7c0.9,0,1.6,0.3,2,0.9c0.3,0.4,0.5,1,0.5,1.9v1.8c0,0.8-0.1,1.3-0.3,1.7l0.8,0.7l-0.4,0.5L197.3,40z  M195.6,38.7l0.4-0.5l1,0.8c0.2-0.4,0.2-0.6,0.2-1.2v-1.6c0-0.8-0.1-1.2-0.4-1.6c-0.3-0.4-0.7-0.6-1.3-0.6c-0.6,0-1.1,0.2-1.4,0.7 c-0.2,0.4-0.3,0.8-0.3,1.5v1.6c0,0.8,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,0.8-0.1,1.1-0.4L195.6,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M200.9,40.5h-0.8v-7.1h2.4c0.8,0,1.3,0.1,1.7,0.5c0.3,0.4,0.5,0.8,0.5,1.5c0,1.2-0.5,1.8-1.5,2l1.6,3.2h-0.9 l-1.5-3.1h-1.5V40.5z M202.5,36.7c0.9,0,1.4-0.4,1.4-1.3c0-0.9-0.5-1.3-1.5-1.3h-1.5v2.7H202.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotHist);
export default __webpack_public_path__ + "static/media/lot_hist.27531353f09dd58a5c6bbada4307b712.svg";
export { ForwardRef as ReactComponent };